var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"menu-nav"},[_vm._l((_vm.headerMenuItems),function(headerMenuItem,index){return [(!headerMenuItem.submenu)?_c('parent-menu-item',{attrs:{"menu":headerMenuItem,"menuId":index}}):[_c('parent-menu-group',{attrs:{"menu":headerMenuItem,"menuId":index}})]]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }